import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const PreventAuthRoute = ({ children }) => {
    const location = useLocation();
    // Otantike kullanıcıların erişebilmesini istediğimiz yollar (pathname bazlı)
    const allowIfAuthenticated = [
        '/instant-payment',
        '/instant-payment-success',
        '/instant-payment-failed'
    ];
    const isAllowedForAuthed = allowIfAuthenticated.includes(location.pathname)
        || location.pathname.startsWith('/odeme/');

    // Oturum durumunu kontrol et (token artık HttpOnly cookie'de, authUser bayrağını kullan)
    const isAuthenticated = !!localStorage.getItem("authUser");

    if (isAuthenticated && !isAllowedForAuthed) {
        // Eğer kullanıcı zaten giriş yapmışsa ve yol allowlist'te değilse, ana sayfaya yönlendir
        return <Navigate to="/dashboard" replace />;
    }

    // Eğer kullanıcı giriş yapmamışsa, istenen sayfayı (children) göster.
    return children;
};

export default PreventAuthRoute;